import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import useStyles from './Alert.style.js';
import { connect } from 'react-redux';
import { closeAlert } from '../store/legacy/actions/alertActions';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const ChowbusAlertContent = (props) => {
  const classes = useStyles();
  const { className, message, onClose, variant, action, ...other } = props;
  const Icon = variantIcon[variant];
  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby='client-snackbar'
      message={
        <span id='client-snackbar' className={classes.message}>
          {Icon && <Icon className={classNames(classes.icon, classes.iconVariant)} />}
          {message}
        </span>
      }
      action={
        action || [
          <IconButton
            key='close'
            aria-label='Close'
            color='inherit'
            className={classes.close}
            onClick={onClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]
      }
      {...other}
    />
  );
};

/** Component used to show information to the user. Usually it is a result of an action the user performed */
export const ChowbusAlert = (props) => {
  const { open, time, vertical, horizontal, onClose, closeAlert, ...rest } = props;

  const onAlertClose = () => {
    closeAlert();
    if (onClose) {
      onClose();
    }
  };

  if (!time) {
    return (
      open && (
        <ChowbusAlertContent className={props.classes.content} {...rest} onClose={onAlertClose} />
      )
    );
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical,
        horizontal,
      }}
      open={open}
      autoHideDuration={time}
      onClose={onAlertClose}>
      <ChowbusAlertContent {...rest} onClose={onAlertClose} />
    </Snackbar>
  );
};

ChowbusAlert.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  /** time in ms used to determine when the alert will close on its own */
  time: PropTypes.number,
  /** Needed if time prop is passed in, used to anchor the Alert */
  vertical: PropTypes.oneOf(['bottom', 'top']),
  /** Needed if time prop is passed in, used to anchor the Alert */
  horizontal: PropTypes.oneOf(['center', 'left', 'right']),
};

const mapStateToProps = (state) => {
  const { open, message, action, variant, vertical, horizontal, onClose, time } = state.alert;
  return {
    open,
    message,
    action,
    variant,
    vertical,
    horizontal,
    onClose,
    time,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeAlert: () => dispatch(closeAlert()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChowbusAlert);
